import { createFileRoute } from "@tanstack/react-router";
import { kennelThreadRoute, KennelThreadPage } from "@/features/provider-home";

export const Route = createFileRoute("/kennel/_dashboard/messages/$threadId")({
    ssr: kennelThreadRoute.ssr,
    head: kennelThreadRoute.head,
    component: KennelThreadPage,
});
